import React from 'react';
import PreviewCompatibleImage from '../PreviewCompatibleImage';
//import Carousel from '@brainhubeu/react-carousel';
//import '@brainhubeu/react-carousel/lib/style.css';


const testimonials = [
  {
    image: '/img/clients/shift.png',
    client: 'Accompany.io',
    quote: "“We ran our first ever PEN test with Cypress, who were recommended by a security expert that we knew. They provided a clear process, did a great assessment and helped us understand how we would remediate the issues that were raised. Three months later we had them re-test, and got the all clear. The clarity of their report helped us get there so quickly. We'll keep using them as we scale.”"
  },
  {
    image: '/img/brands/arrt.png',
    client: 'ARRT (American Registry of Radiologic Technologists)',
    quote: "Working with Cypress Data Defense has been an absolute pleasure every step of the way. From their world class training to assistance with our Secure SDLC process to a thorough hybrid penetration test they helped us implement security every step of the way."
  },
  {
    image: '/img/clients/bluecompass.png',
    client: 'Blue Compass',
    quote: '“Blue Compass engaged Cypress Data Defense to ensure our development process continues to be secure in this ever-changing landscape. Cypress Data Defense provided an implementation plan to our development and network people and after many conversations back-and-forth, we have a great security foundation. We look forward to working with Cypress Data Defense on additional plans in the future."'
  }
];

export default () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const screenWidth = window.screen.width;
  const arrowLeft = screenWidth > 460 ? <button className="carousel__btn" style={{ left: 0 }}>&lt;</button> : null;
  const arrowRight = screenWidth > 460 ? <button className="carousel__btn" style={{ right: 0 }}>&gt;</button> : null;

  //const Carousel = require('@brainhubeu/react-carousel').default;
  const Carousel = require('@itseasy21/react-elastic-carousel').default;

  return (
    <section className="section" style={{ background: 'rgb(83, 197, 209)' }}>
      <div className="container custom-slider">
        <h2 style={{
          fontSize: '2rem',
          color: 'white',
          textAlign: 'center',
          fontWeight: '500'
        }}>WHAT OUR CLIENTS SAY</h2>
        <Carousel
          dots
          clickToChange
          infinite
          centered
          arrowLeft={arrowLeft}
          arrowRight={arrowRight}
          addArrowClickHandler>
          {testimonials.map((el, i) => (
            <div style={{
              background: 'white',
              padding: '3rem 2rem 2rem',
              textAlign: 'center',
              maxWidth: '800px',
              margin: '3rem 3px 0',
              boxShadow: '2px 1px 2px #888',
              position: 'relative',
            }}
              key={i}>
              <div className="carousel__img">
                <PreviewCompatibleImage imageInfo={el} />
              </div>
              <div style={{ fontWeight: '500', marginTop: '5px' }}>{el.client}</div>
              <div style={{ marginTop: '1rem', color: '#848d90', lineHeight: 1.3 }}>{el.quote}</div>
            </div>
          ))}
        </Carousel>
        {/*<Dots
        number={testimonials.length}
        thumbnails={testimonials.map(() => <div style={{
          width: '7px',
          height: '7px',
          border: '1px solid #fff',
          borderRadius: '3px'
        }}></div>)}
      />*/}
      </div>
    </section>
  );
}
